// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"93881660","239":"569de25a","277":"f509f3fe","320":"0d9d0d99","417":"db362ef1","457":"ab09257b","502":"4dcd837e","856":"9c9e41f9","866":"6c07d750"}[chunkId] + ".chunk.js";
};